export default {
    methods: {
        fix_vh_android() {
            // if (window.innerWidth <= 1023) {
               
                let el = document.querySelectorAll(".mob__100");
            
                el.forEach(e => {
                    // e.style.height = window.innerHeight + 'px' + '!imoportant';
                    if(e.classList.contains("scrolled")){
                        e.setAttribute(
                            "style",
                            `height: ${window.innerHeight + 150 }px !important;`
                        );
                    } else {
                        e.setAttribute(
                            "style",
                            `height: ${window.innerHeight}px !important;`
                        );
                    }
                 
                });
            // }
        }
    },
    mounted(){
        if(window.innerWidth <= 1023){
            this.fix_vh_android();
        }
    }
};